import { render, staticRenderFns } from "./kingscalling.vue?vue&type=template&id=e315d922&scoped=true"
import script from "./kingscalling.vue?vue&type=script&lang=js"
export * from "./kingscalling.vue?vue&type=script&lang=js"
import style0 from "./kingscalling.vue?vue&type=style&index=0&id=e315d922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e315d922",
  null
  
)

export default component.exports